// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { initAnalytics } from './utils/analytics';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './index.css';
import './i18n/i18n'; // ✅ i18n inizializzato prima del render
import App from './App';
import toast from 'react-hot-toast';

initAnalytics();

// in fondo al file, sostituisci serviceWorker.unregister() con:
serviceWorkerRegistration.register({
    onUpdate: () => {
        toast('🔄 Aggiornamento disponibile — ricarica l\'app', { duration: 5000 });
    },
});
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);